import React from 'react'
import PropTypes from 'prop-types'
import { Columns } from 'src/components/layout'
import BlockToolbar from '../BlockToolbar'
import Block from '../Block'

const BlockWithToolbar = ({ toolbar, ...props }) => {
  return (
    <Columns layout="auto 1" align="start stretch" gap="0" reversed>
      <BlockToolbar>{toolbar}</BlockToolbar>
      <Block {...props} />
    </Columns>
  )
}

BlockWithToolbar.propTypes = {
  toolbar: PropTypes.node,
}

export default BlockWithToolbar
